/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
  Divider,
  Segment,
  Dropdown,
  Menu,
} from 'semantic-ui-react';
import config from '../../../config';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import NavBar from '../../components/NavBar';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import BusinessUnitActivities from '../../components/BusinessUnitActivities';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { routes } from './navigations';

class Activities extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    routeParams: PropTypes.shape({
      id: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = props.data || [];
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    const activitiesData = [];
    const menuIsTab = window.innerWidth <= 590;
    return {
      data,
      loading,
      query,
      search,
      activitiesData,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    this.state = state;
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    const { query } = this.props.location;
    this.getBusinessUnitActivities(query);
  }
  componentWillReceiveProps(nextProps) {
    const { query } = nextProps.location;
    const state = Activities.getPropsToState(nextProps);
    if (this.state.activitiesData) {
      state.activitiesData = this.state.activitiesData;
    }
    this.setState({ ...state }, () => {
      if (!this.state.activitiesData) {
        this.getBusinessUnitActivities(query);
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async getBusinessUnitActivities(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/company_branches/${this.props.routeParams.id}/activities/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const activitiesData = await res.json();
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        count,
        limit,
        offset,
        activitiesData,
      });
      await this.setLoading(false);
    }
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== this.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    const galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== this.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    const locationResize = window.innerWidth <= 375;
    if (locationResize !== this.state.locationResize) {
      state.locationResize = locationResize;
    }
    this.setState({ ...state });
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('bookApiURL'))) {
      e.preventDefault();
      const winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    } else {
      this.setState({ search: '' });
    }
  }
  handleOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  async replaceQuery(query, resetPage = false) {
    await this.setLoading(true);
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) queryNew.page = 1;
    await this.getBusinessUnitActivities(query);
    store.dispatch(replace(`/business_units/${this.props.routeParams.id}/activities/?${encodeSearch(queryNew)}`));
    await this.setLoading(false);
  }
  sortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'business_unit_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'business_unit_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  render() {
    const { pathname } = this.props.location;
    const { activitiesData } = this.state;
    const { t } = this.props;
    const links = routes(this.props.routeParams.id).map(l => ({
      ...l,
      text: t(l.text),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
        />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16}>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                placeholder={t('Search')}
                setAdvanceFilter={() => {}}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.activitiesData.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              />
            </Grid.Column>
            <Grid.Column width={16} textAlign="center">
              <Divider horizontal />
              <Segment>
                <BusinessUnitActivities
                  data={activitiesData || []}
                  hasAccess={this.hasAccess()}
                  loading={this.state.loading}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
export default withTranslation(namespaces)(connect(Activities.mapStateToProps)(Activities));



// WEBPACK FOOTER //
// ./src/containers/BusinessUnits/Activities.jsx